module.exports = __webpack_public_path__ + "img/圆3.e08bda59.svg";